import { isNonEmptyArray } from './isNonEmptyArray';

export const lineSeparatedList = (items: string[], defaultValue: string = ''): string => {
	if (isNonEmptyArray<string>(items)) {
		return items.map((item: any) => `<p>${item.id}</p>`).join('\n');
	} else {
		return `<p>${defaultValue}</p>`;
	}
};
